import { Dialog } from '@Common/Controls/Dialog';
import urlHelper from '@Common/Helpers/UrlHelper';

export const enum MessageBoxIcons {
    info = 'Informational',
    warning = 'Warning',
    critical = 'Critical'
}

export interface IMessageBoxParameters {
    text: string;
    icon?: MessageBoxIcons;
    dialogTitle?: string;
    width?: string | number;
    maxWidth?: string | number;
    isModal?: boolean;
}

export class MessageBox {
    private closed: IHandler = _.noop;

    constructor(private readonly param: IMessageBoxParameters) {
        this.param = _.defaults(this.param, {
            dialogTitle: altosoft.appName,
            text: '',
            width: 'auto',
            maxWidth: 'auto',
            icon: MessageBoxIcons.info,
            isModal: true
        });
    }

    public onClosed(fn: IHandler): void {
        if (_.isFunction(fn)) {
            this.closed = fn;
        }
    }

    public show(): void {
        const dialog = Dialog({
            title: this.param.dialogTitle,
            width: this.param.width,
            maxWidth: this.param.maxWidth,
            isModal: this.param.isModal,
            className: 'dialog-content-message'
        });

        dialog.ok(() => this.closed());
        dialog.cancel(() => this.closed());
        dialog.wrap([
            `<img src="${urlHelper.getImageUrl(`Dialog/${this.param.icon}.png`)}" />`,
            `<span class="gap-2-left">${this.param.text.replaceAll('\n', '<br/>')}</span>`
        ]);
    }

    public static show(param: IMessageBoxParameters): void;
    public static show(param: IMessageBoxParameters, async: true): Promise<void>;
    public static show(param: IMessageBoxParameters, onClose: IHandler): void;
    public static show(param: IMessageBoxParameters, onCloseOrAsync?: IHandler | true): Promise<void> | void {
        const messageBox = new MessageBox(param);
        messageBox.show();
        if (onCloseOrAsync) {
            if (onCloseOrAsync === true) {
                return new Promise(resolve => messageBox.onClosed(resolve));
            }
            messageBox.onClosed(onCloseOrAsync);
        }
    }
}
